import type { SVGProps } from "react";

type P = SVGProps<SVGSVGElement>;

const base = (props: P) => ({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  width: 24,
  height: 24,
  ...props,
});

export const IconPlaceholder = (p: P) => (
  <svg {...base(p)}>
    <polygon points="12,2.5 21,7.5 21,16.5 12,21.5 3,16.5 3,7.5" />
  </svg>
);

export const IconStar2 = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 3 L13.4 10.6 L21 12 L13.4 13.4 L12 21 L10.6 13.4 L3 12 L10.6 10.6 Z" />
  </svg>
);

export const IconStar4 = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 2 L14 9 L21 10 L16 15 L17 22 L12 18.5 L7 22 L8 15 L3 10 L10 9 Z" />
  </svg>
);

export const Icon3dSpace = (p: P) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="3" />
    <circle cx="5" cy="5" r="1.5" />
    <circle cx="19" cy="5" r="1.5" />
    <circle cx="5" cy="19" r="1.5" />
    <circle cx="19" cy="19" r="1.5" />
    <path d="M6 6 l4 4 M18 6 l-4 4 M6 18 l4 -4 M18 18 l-4 -4" />
  </svg>
);

export const IconList = (p: P) => (
  <svg {...base(p)}>
    <line x1="8" y1="6" x2="20" y2="6" />
    <line x1="8" y1="12" x2="20" y2="12" />
    <line x1="8" y1="18" x2="20" y2="18" />
    <circle cx="4" cy="6" r="1.2" fill="currentColor" />
    <circle cx="4" cy="12" r="1.2" fill="currentColor" />
    <circle cx="4" cy="18" r="1.2" fill="currentColor" />
  </svg>
);

export const IconAlert = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 3 L22 20 L2 20 Z" />
    <line x1="12" y1="10" x2="12" y2="14" />
    <circle cx="12" cy="17" r="0.8" fill="currentColor" />
  </svg>
);

export const IconMenu = (p: P) => (
  <svg {...base(p)}>
    <line x1="3.5" y1="6" x2="20.5" y2="6" />
    <line x1="3.5" y1="12" x2="20.5" y2="12" />
    <line x1="3.5" y1="18" x2="20.5" y2="18" />
  </svg>
);

export const IconX = (p: P) => (
  <svg {...base(p)}>
    <line x1="5" y1="5" x2="19" y2="19" />
    <line x1="19" y1="5" x2="5" y2="19" />
  </svg>
);

export const IconAsteriskHexagon = (p: P) => (
  <svg {...base(p)}>
    <polygon points="12,3 20,7.5 20,16.5 12,21 4,16.5 4,7.5" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="8.5" y1="10" x2="15.5" y2="14" />
    <line x1="15.5" y1="10" x2="8.5" y2="14" />
  </svg>
);

export const IconCard = (p: P) => (
  <svg {...base(p)}>
    <rect x="2.5" y="5.5" width="19" height="13" rx="2.5" />
    <line x1="2.5" y1="9.5" x2="21.5" y2="9.5" />
    <line x1="6" y1="14.5" x2="10" y2="14.5" />
  </svg>
);

export const IconGear = (p: P) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15 a1.7 1.7 0 0 0 .3 1.9 l.1 .1 a2 2 0 0 1 -2.8 2.8 l-.1 -.1 a1.7 1.7 0 0 0 -1.9 -.3 a1.7 1.7 0 0 0 -1 1.5 V21 a2 2 0 0 1 -4 0 v-.1 a1.7 1.7 0 0 0 -1.1 -1.5 a1.7 1.7 0 0 0 -1.9 .3 l-.1 .1 a2 2 0 0 1 -2.8 -2.8 l.1 -.1 a1.7 1.7 0 0 0 .3 -1.9 a1.7 1.7 0 0 0 -1.5 -1 H3 a2 2 0 0 1 0 -4 h.1 a1.7 1.7 0 0 0 1.5 -1.1 a1.7 1.7 0 0 0 -.3 -1.9 l-.1 -.1 a2 2 0 0 1 2.8 -2.8 l.1 .1 a1.7 1.7 0 0 0 1.9 .3 H9 a1.7 1.7 0 0 0 1 -1.5 V3 a2 2 0 0 1 4 0 v.1 a1.7 1.7 0 0 0 1 1.5 a1.7 1.7 0 0 0 1.9 -.3 l.1 -.1 a2 2 0 0 1 2.8 2.8 l-.1 .1 a1.7 1.7 0 0 0 -.3 1.9 v0 a1.7 1.7 0 0 0 1.5 1 H21 a2 2 0 0 1 0 4 h-.1 a1.7 1.7 0 0 0 -1.5 1 z" />
  </svg>
);

export const IconExit = (p: P) => (
  <svg {...base(p)}>
    <path d="M9 21 H5 a2 2 0 0 1 -2 -2 V5 a2 2 0 0 1 2 -2 h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

export const IconPlus = (p: P) => (
  <svg {...base(p)}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const IconPlusCircle = (p: P) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9.5" />
    <line x1="12" y1="7.5" x2="12" y2="16.5" />
    <line x1="7.5" y1="12" x2="16.5" y2="12" />
  </svg>
);

export const IconDotMenuH = (p: P) => (
  <svg {...base(p)} fill="currentColor" stroke="none">
    <circle cx="5" cy="12" r="1.6" />
    <circle cx="12" cy="12" r="1.6" />
    <circle cx="19" cy="12" r="1.6" />
  </svg>
);

export const IconMinus = (p: P) => (
  <svg {...base(p)}>
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const IconPause = (p: P) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="10" />
    <line x1="10" y1="8" x2="10" y2="16" />
    <line x1="14" y1="8" x2="14" y2="16" />
  </svg>
);

export const IconPlay = (p: P) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="10" />
    <polygon points="10,8 16,12 10,16" fill="currentColor" stroke="none" />
  </svg>
);

export const IconTrash = (p: P) => (
  <svg {...base(p)}>
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1 -2 2 H8 a2 2 0 0 1 -2 -2 L5 6" />
    <path d="M10 11 v6 M14 11 v6" />
    <path d="M9 6 V4 a1 1 0 0 1 1 -1 h4 a1 1 0 0 1 1 1 v2" />
  </svg>
);

export const IconEye = (p: P) => (
  <svg {...base(p)}>
    <path d="M1 12 s4 -8 11 -8 s11 8 11 8 s-4 8 -11 8 s-11 -8 -11 -8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const IconEyeOff = (p: P) => (
  <svg {...base(p)}>
    <path d="M9.9 4.2 A10.4 10.4 0 0 1 12 4 c7 0 11 8 11 8 a18.5 18.5 0 0 1 -2.2 3.2" />
    <path d="M6.6 6.6 A18.4 18.4 0 0 0 1 12 s4 8 11 8 a10.9 10.9 0 0 0 5.4 -1.6" />
    <path d="M9.9 9.9 a3 3 0 0 0 4.2 4.2" />
    <path d="M2 2 L22 22" />
  </svg>
);

export const IconWand = (p: P) => (
  <svg {...base(p)}>
    <path d="M21.6 3.6 l-1.2 -1.2 a1.2 1.2 0 0 0 -1.7 0 L2.4 18.7 a1.2 1.2 0 0 0 0 1.7 l1.2 1.2 a1.2 1.2 0 0 0 1.7 0 L21.6 5.3 a1.2 1.2 0 0 0 0 -1.7 z" />
    <path d="M14 7 l3 3" />
    <path d="M5 6 v4 M3 8 h4" />
    <path d="M19 14 v4 M17 16 h4" />
    <path d="M10 2 v2 M9 3 h2" />
  </svg>
);

export const IconCopy = (p: P) => (
  <svg {...base(p)}>
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M5 15 H4 a2 2 0 0 1 -2 -2 V4 a2 2 0 0 1 2 -2 h9 a2 2 0 0 1 2 2 v1" />
  </svg>
);

export const IconChevronDown = (p: P) => (
  <svg {...base(p)}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export const IconClock = (p: P) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9" />
    <polyline points="12 7 12 12 15 14" />
  </svg>
);

export const IconChevronLeft = (p: P) => (
  <svg {...base(p)}>
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const IconChevronRight = (p: P) => (
  <svg {...base(p)}>
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

export const IconChat = (p: P) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M8 11 H16 M8 14 H13" />
  </svg>
);

export const IconSend = (p: P) => (
  <svg {...base(p)}>
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);

export const IconGithub = (p: P) => (
  <svg {...base(p)} fill="currentColor" stroke="none">
    <path d="M12 .5 A11.5 11.5 0 0 0 .5 12 a11.5 11.5 0 0 0 7.9 10.9 c.6 .1 .8 -.25 .8 -.55 v-2 c-3.2 .7 -3.9 -1.55 -3.9 -1.55 c-.5 -1.35 -1.3 -1.7 -1.3 -1.7 c-1.05 -.7 .08 -.7 .08 -.7 c1.15 .08 1.8 1.2 1.8 1.2 c1.05 1.8 2.75 1.3 3.4 1 c.1 -.75 .4 -1.3 .75 -1.6 c-2.55 -.3 -5.25 -1.3 -5.25 -5.7 c0 -1.25 .45 -2.3 1.2 -3.1 c-.1 -.3 -.5 -1.5 .1 -3.1 c0 0 1 -.3 3.2 1.2 a11 11 0 0 1 5.8 0 c2.2 -1.5 3.2 -1.2 3.2 -1.2 c.6 1.6 .2 2.8 .1 3.1 c.75 .8 1.2 1.85 1.2 3.1 c0 4.4 -2.7 5.4 -5.3 5.7 c.4 .35 .8 1.05 .8 2.15 v3.2 c0 .3 .2 .65 .8 .55 A11.5 11.5 0 0 0 23.5 12 A11.5 11.5 0 0 0 12 .5 z" />
  </svg>
);

export const IconGoogle = (p: P) => (
  <svg {...base(p)} fill="currentColor" stroke="none">
    <path d="M21.6 12.23 c0 -.74 -.07 -1.45 -.19 -2.13 H12 v4.04 h5.4 a4.62 4.62 0 0 1 -2 3.03 v2.52 h3.24 c1.9 -1.75 2.96 -4.32 2.96 -7.46 z" />
    <path d="M12 22 c2.7 0 4.97 -.9 6.62 -2.43 l-3.24 -2.52 c-.9 .6 -2.05 .96 -3.38 .96 c-2.6 0 -4.8 -1.76 -5.6 -4.12 H3.05 v2.6 A10 10 0 0 0 12 22 z" />
    <path d="M6.4 13.89 a6 6 0 0 1 0 -3.78 V7.51 H3.05 a10 10 0 0 0 0 8.98 l3.35 -2.6 z" />
    <path d="M12 5.97 c1.47 0 2.78 .51 3.82 1.5 l2.86 -2.86 A10 10 0 0 0 12 2 A10 10 0 0 0 3.05 7.51 l3.35 2.6 C7.2 7.74 9.4 5.97 12 5.97 z" />
  </svg>
);

export const IconYandex = (p: P) => (
  <svg {...base(p)} stroke="none">
    <path
      d="M12 23.9755C18.6139 23.9755 23.9756 18.6139 23.9756 12C23.9756 5.38606 18.6139 0.0244141 12 0.0244141C5.38611 0.0244141 0.0244751 5.38606 0.0244751 12C0.0244751 18.6139 5.38611 23.9755 12 23.9755Z"
      fill="#A3A3A3"
    />
    <path
      d="M16.3333 19.5177H13.7044V6.51553H12.5333C10.3867 6.51553 9.26221 7.58887 9.26221 9.19109C9.26221 11.0089 10.0378 11.8511 11.6422 12.9244L12.9644 13.8155L9.16443 19.5155H6.33777L9.75777 14.4266C7.7911 13.0222 6.68443 11.6511 6.68443 9.33775C6.68443 6.44665 8.69999 4.47998 12.5155 4.47998H16.3155V19.5133H16.3333V19.5177Z"
      fill="black"
    />
  </svg>
);

export const IconKey = (p: P) => (
  <svg {...base(p)}>
    <circle cx="8" cy="15" r="4" />
    <path d="M10.83 12.17 L20 3" />
    <path d="M16 7 l3 3" />
    <path d="M18 5 l3 3" />
  </svg>
);

export const IconSiteGlobe = (p: P) => (
  <svg {...base(p)} width={16} height={16}>
    <circle cx="12" cy="12" r="9" />
    <ellipse cx="12" cy="12" rx="4" ry="9" />
    <line x1="3" y1="12" x2="21" y2="12" />
  </svg>
);

export const IconArrow = (p: P) => (
  <svg {...base(p)}>
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

export const IconCheck = (p: P) => (
  <svg {...base(p)}>
    <polyline points="5 12 10 17 19 7" />
  </svg>
);

export const IconDownload = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 3 v12" />
    <polyline points="7 10 12 15 17 10" />
    <path d="M5 20 h14" />
  </svg>
);

export const IconRefresh = (p: P) => (
  <svg {...base(p)}>
    <polyline points="23 4 23 10 17 10" />
    <path d="M20.5 14 a9 9 0 1 1 -2.1 -7.4" />
  </svg>
);

export const IconBell = (p: P) => (
  <svg {...base(p)}>
    <path d="M18 16 v-5 a6 6 0 0 0 -12 0 v5 l-2 3 h16 z" />
    <path d="M10 21 h4" />
  </svg>
);
